import React from "react";

/**
 * Year selector for the leave reports.
 *
 * Leave balances are per-year and both report endpoints have always accepted a
 * `year` param — the pages simply never sent one, so only the current year was
 * ever reachable from the UI.
 *
 * Lives here rather than in ReportsPage because MyReportsPage (employee-facing)
 * needs it too, and should not have to import the admin reports page to get it.
 */
export default function ReportYearPicker({
  year, onChange, thisYear, years = 5,
}: {
  year: number;
  onChange: (y: number) => void;
  thisYear: number;
  years?: number;
}) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
      <label htmlFor="report-year" style={{ fontSize: 13, fontWeight: 600, color: "#64748b" }}>Year</label>
      <select
        id="report-year"
        value={year}
        onChange={e => onChange(Number(e.target.value))}
        style={{
          padding: "7px 10px", border: "1px solid #cbd5e1", borderRadius: 6,
          fontSize: 13, fontWeight: 600, color: "#0f172a", background: "white",
          minHeight: 44,
        }}
      >
        {Array.from({ length: years }, (_, i) => thisYear - i).map(y => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>
    </div>
  );
}
